import React, { useCallback, useState } from 'react';
import { ExportExcel } from '../../../utils/Excel/exportExcel';
import ReactTable from '../../../utils/ReactTable/ReactTable';
import useOnceEffect from '../../../Hooks/useOnceEffect';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import ModalPicker from '../../../utils/DatesPicker/ModalPicker';
import useToggle from '../../../Hooks/useToggle';
import moment from 'moment';

const AplicantsReport = () => {

    const [data, setData] = useState([])
    const [modal, toggleModal] = useToggle(false)
    const history = useHistory();

    function tableHead() {
        return [
            { Header: "Nombre del Aplicante", accessor: "nombre" },
            { Header: "Sexo del Aplicante", accessor: "sexo" },
            { Header: "Edad del Aplicante", accessor: "edad" },
            { Header: "Fecha de aplicación", accessor: "fechaAplicacion" },
            { Header: "Departamento", accessor: "departamento" },
            { Header: "Municipio", accessor: "municipio" },
            { Header: "Nombre de la vacante", accessor: "vacante" },
            { Header: "Tipo de Contrato", accessor: "vacante_contrato" },
        ]
    }


    function exportTable() {

        ExportExcel(
            data,
            "Reporte de Aplicante"
        );
    }

    const getData = useCallback((start, end) => {
        axios.get("reportes/admin/aplicants", {
            params: {
                start: start ?? "",
                end: end ?? ""
            }
        })
        .then(({ data }) => {
            setData(data)
        })

    }, [setData])

    useOnceEffect(() => {
        getData(null, null)
    })

    function onOk(date1, date2) {

        toggleModal()
        setData([])
        

        getData(
            moment(date1).add(1, "d").format("DD-MM-YYYY"),
            moment(date2).add(1, "d").format("DD-MM-YYYY")
        );
    }


    return (
        <>
            <main className='container'>
                <div className='col-12 col-md-6 col-lg-12 '>
                    <div className='card mt-3 '>
                        <div className='card-body'>
                        <h3>Reporte Aplicante</h3>
                        <div className='row'>
                                <div className="col-12 col-lg-8 d-flex p-3">
                                    <button className='btn-deg mb-3 mt-3' style={{ width: "fit-content", padding: "5px 10px" }} onClick={exportTable}>Descargar Reporte</button>

                                    <button className='btn-deg mb-3 mt-3' style={{ width: "fit-content", padding: "5px 10px" }} onClick={toggleModal}>Aplicar filtro por fecha</button>

                                    <button className='btn-deg mb-3 mt-3' style={{ width: "fit-content", padding: "5px 10px" }} onClick={_ => getData(null, null)} >Borrar Filtro por fecha</button>
                                </div>

                                <div className="col-12 col-lg-4 d-flex d-flex justify-content-end  p-3">
                                    <button className="btn-deg" onClick={() => history.push("/admin/reports")} style={{ width: "fit-content", padding: "5px 10px" }}>
                                        <i className="fas fa-arrow-left" ></i>
                                    </button>
                                </div>
                            </div>

                            <ReactTable
                                dataset={data}
                                columnset={tableHead()}
                                className="table table-hover table-bordered table-striped"
                                filterDisabled
                            />
                        </div>
                    </div>
                </div>
            </main>

            <ModalPicker show={modal} onHide={toggleModal} onOk={onOk} />
        </>
    );
};



export default AplicantsReport;